
import Popup from 'vux/src/components/popup/index.vue'

import news from "../../../components/base/home/news.vue";
import { commonApi } from "@/common/index";
import GMarquee from "@/common/components/g-marquee/";
export default {
components: { news, Popup, GMarquee },
data() {
return {
show: false,
list: [],
content: "",
speed: 0,
};
},
created() {
this._initPages();
},
methods: {
_initPages() {

commonApi.HOMEBEFORE.pushInfoList().then((data) => {
this.list = data;
data.forEach((item, index) => {
this.content += `${index + 1}. ${item.name}:${item.content}`;
});
this.speed = this.list.length * 2000;
});
},

_close() {
this.show = false;
},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/Home/components/notice.vue